import { render, staticRenderFns } from "./HistoricDetails.vue?vue&type=template&id=0fce19ad&lang=pug"
import script from "./HistoricDetails.vue?vue&type=script&lang=js"
export * from "./HistoricDetails.vue?vue&type=script&lang=js"
import style0 from "./HistoricDetails.vue?vue&type=style&index=0&id=0fce19ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports